// extracted by mini-css-extract-plugin
module.exports = {"SchneiderTopBar":"SchneiderTopBar__SchneiderTopBar___1j9Qa"};